import { CODE_KEY_MAP } from './codeKeyMap.js';
import { isWindowsPlatform } from '../types/global.js';
import { hasMacOSKbd } from '@fabric-app/utils/detection';

const modifierKeys = [
  "control",
  "ctrl",
  "shift",
  "alt",
  "meta",
  "cmd"
];
const isMac = hasMacOSKbd();
const keyToDisplayValue = (item) => {
  switch (item.toLowerCase()) {
    case "ctrl":
    case "control":
      return hasMacOSKbd() ? "⌃" : "ctrl";
    case "alt":
      return isMac ? "⌥" : "alt";
    case "shift":
      return "⇧";
    case "meta":
      return isWindowsPlatform() ? "win" : hasMacOSKbd() ? "⌘" : "meta";
    default: {
      const value = CODE_KEY_MAP[item.toLowerCase()] || item;
      return value.length === 1 ? value.toUpperCase() : value;
    }
  }
};
const shortKeysToDisplayValue = (keys) => {
  return keys.map((item) => {
    switch (item.toLowerCase()) {
      case "ctrl":
        return hasMacOSKbd() ? "⌃" : "ctrl";
      case "alt":
        return isMac ? "⌥" : "alt";
      case "shift":
        return "⇧";
      case "meta":
        return isWindowsPlatform() ? "win" : hasMacOSKbd() ? "⌘" : "meta";
      case "mod":
        return isWindowsPlatform() ? "ctrl" : hasMacOSKbd() ? "⌘" : "ctrl";
      default: {
        const value = CODE_KEY_MAP[item.toLowerCase()] || item;
        return value.length === 1 ? value.toUpperCase() : value;
      }
    }
  }).join(" + ");
};

export { keyToDisplayValue, modifierKeys, shortKeysToDisplayValue };
//# sourceMappingURL=modifierKeys.js.map
